import { CartItem, useCartStore } from "@/store/shipping-cart/cart-store";

export function useCart() {
    const {
        items,
        card_status,
        addItem,
        removeItem,
        updateQuantity,
        clearCart,
        updateStatus,
        clearActiveItems,
        changeCardStatus,
        replaceEntireCart,
        updateEntireCart,
    } = useCartStore();

    const addToCart = (item: CartItem) => {
        addItem(item);
    };

    const removeFromCart = (unique_id: string | null | undefined) => {
        removeItem(unique_id);
    };

    const updateItemQuantity = (unique_id: string | null, quantity: number) => {
        if (quantity <= 0) {
            removeItem(unique_id);
        } else {
            updateQuantity(unique_id, quantity);
        }
    };

    const updateCart = (newItems: CartItem[]) => {
        updateEntireCart(newItems);
    };

    return {
        items,
        card_status,
        addToCart,
        removeFromCart,
        updateItemQuantity,
        clearCart,
        updateStatus,
        changeCardStatus,
        clearActiveItems,
        updateEntireCart,
        replaceEntireCart,
        updateCart,
    };
}